import './set-public-path'

import heroDesktop from '../assets/hero_desktop_builder.png'
import noContactsBgSvg from '../assets/no_contacts_bg.svg'

const brandTheme = {
    "typography": {
        "fontFamily": "'proxima-nova',sans-serif",
        "h1": {
            "fontFamily": "'proxima-nova',sans-serif"
        },
        "h2": {
            "fontFamily": "'proxima-nova',sans-serif"
        },
        "h3": {
            "fontFamily": "'proxima-nova',sans-serif"
        },
        "h4": {
            "fontFamily": "'proxima-nova',sans-serif"
        },
        "h5": {
            "fontFamily": "'proxima-nova',sans-serif"
        },
        "h6": {
            "fontFamily": "'proxima-nova',sans-serif"
        },
        "body1": {
            "fontFamily": "'proxima-nova',sans-serif"
        },
        "body2": {
            "fontFamily": "'proxima-nova',sans-serif"
        },
        "subtitle1": {
            "fontFamily": "'proxima-nova',sans-serif"
        },
        "subtitle2": {
            "fontFamily": "'proxima-nova',sans-serif"
        },
        "button": {
            "fontFamily": "'proxima-nova',sans-serif"
        },
        "caption": {
            "fontFamily": "'proxima-nova',sans-serif"
        },
        "overline": {
            "fontFamily": "'proxima-nova',sans-serif"
        }
    },
   "palette": {
      "primary": {
         "main": "#2C76DC",
         "lighter": "#81BCF6",
         "light": "#609DF8",
         "dark": "#1D2C5C",
         "backgroundText": "#1F2A3A",
         "lighterText": "#1F2A3A",
         "lightText": "#1F2A3A",
         "text": "#1F2A3A"
      },
      "green": {
         "main": "#17B212",
         "lighter": "#85F582",
         "light": "#36DF31",
         "dark": "#1D741A",
         "backgroundText": "#122E12",
         "lighterText": "#122E12",
         "lightText": "#122E12",
         "text": "#122E12"
      },
      "success": {
         "main": "#17B212",
         "lighter": "#85F582",
         "light": "#36DF31",
         "dark": "#1D741A",
         "backgroundText": "#122E12",
         "lighterText": "#122E12",
         "lightText": "#122E12",
         "text": "#122E12"
      },
      "orange": {
         "main": "#F89C24",
         "lighter": "#FFD399",
         "dark": "#9B5C0A",
         "text": "#2E2213",
         "light": "#FFB24E"
      },
      "warning": {
         "main": "#F89C24",
         "lighter": "#FFD399",
         "dark": "#9B5C0A",
         "text": "#2E2213",
         "light": "#FFB24E"
      },
      "red": {
         "main": "#F62F26",
         "lighter": "#FBA6A2",
         "light": "#F8706A",
         "dark": "#9E1B15",
         "backgroundText": "#381413",
         "lighterText": "#381413",
         "lightText": "#381413",
         "text": "#381413"
      },
      "error": {
         "main": "#F62F26",
         "lighter": "#FBA6A2",
         "light": "#F8706A",
         "dark": "#9E1B15",
         "backgroundText": "#381413",
         "lighterText": "#381413",
         "lightText": "#381413",
         "text": "#381413"
      }
   },
   "overrides": {
      "MuiPrivateTabIndicator": {
         "colorSecondary": {
            "backgroundColor": "#2C76DC"
         }
      },
      "MuiTabIndicator": {
         "colorSecondary": {
            "backgroundColor": "#2C76DC"
         }
      },
      "MuiLinearProgress": {
         "barColorPrimary": {
            "backgroundColor": "#2C76DC"
         }
      },
      "MuiSlider": {
         "track": {
            "backgroundColor": "#2C76DC"
         }
      },
      "MuiButton": {
         "containedSecondary": {
            "color": "#2C76DC"
         },
         "outlinedSecondary": {
            "color": "#2C76DC",
            "&:hover": {
               "color": "#2C76DC"
            }
         },
         "containedPrimary": {
            "&:hover": {
               "backgroundColor": "#1D2C5C"
            }
         }
      },
      "MuiCheckbox": {
         "root": {
            "&$checked": {
               "color": "#2C76DC"
            }
         },
         "colorSecondary": {
            "color": "#2C76DC"
         }
      },
      "MuiOutlinedInput": {
         "root": {
            "&$focused $notchedOutline": {
               "borderColor": "#609DF8"
            }
         }
      }
   }
}

brandTheme.assets = {
  dashboardHeroImage: heroDesktop,
  noContactsBgSvg
}

export default brandTheme
